import { render } from "./csrf-input.vue?vue&type=template&id=4c35bba9"
import script from "./csrf-input.vue?vue&type=script&lang=js"
export * from "./csrf-input.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__